import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import type { Address } from "@@/shared/locations/address";
import { addressZodSchema } from "@@/shared/locations/address";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { UserAddressInputType } from "../user-address";
import type { UserAddressId } from "../user-address-id";
import { userAddressIdZodSchema } from "../user-address-id";

type EditAddressCommand = {
    readonly _id: string;
    readonly _type: "EDIT_ADDRESS_COMMAND";

    readonly _createdAt: IsoAndUnixTimestamp;
    readonly addressId: UserAddressId;
    readonly address: Address;
    readonly name?: string;
    readonly details?: string;
    readonly deliveryInstructions?: string;
    readonly inputType: UserAddressInputType;
};

type FactoryParams = Except<EditAddressCommand, "_id" | "_type" | "_createdAt">;
const createEditAddressCommand = (params: FactoryParams) => {
    const command: EditAddressCommand = {
        ...params,
        _id: generateId({ prefix: "edit_address_command__" }),
        _type: "EDIT_ADDRESS_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

const editAddressCommandZodSchema: z.ZodSchema<EditAddressCommand> = z.object({
    _id: idZodSchema,
    _type: z.literal("EDIT_ADDRESS_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    addressId: userAddressIdZodSchema,
    address: addressZodSchema,
    details: z.string(),
    name: z.string(),
    deliveryInstructions: z.string(),
    inputType: z.enum(["GOOGLE_AUTO_COMPLATE", "MANUAL"]),
});

export { createEditAddressCommand, editAddressCommandZodSchema };
export type { EditAddressCommand };
